import { createContext } from 'react';

export interface FirstPaintContextShape {
  firstPaint: boolean;
}

export const FirstPaintContext = createContext<FirstPaintContextShape>({
  firstPaint: null,
});
